<div ngbDropdown placement="bottom-right" *ngIf="user" class="kt-header__topbar-item">

  <div class="kt-header__topbar-wrapper">
    <span class="kt-header__topbar-icon ml-1" *ngIf="isAdmin">
      <div class="circular-progress mini" (click)="openMyProfile()"
        matTooltip="{{'profilepercentagetooltip' | translate}} {{ progressPercent }}% {{'MyProfile.Completed' | translate}}."
        matTooltipPosition="below" [ngStyle]="{'--percent': progressPercent + '%', '--color': progressColor}"
        onkeypress="">
        <div class="circle-bg"></div>
        <div class="inner-circle">{{ progressPercent }}%
        </div>
      </div>
    </span>

    <div ngbDropdownToggle class="kt-header__topbar-wrapper">
      <div class="kt-header__topbar-user kt-margin-l-10 mr-2 profile-username">
        <a class="kt-header__topbar-welcome kt-hidden-mobile" *ngIf="showHi">{{'Hi'|translate}}, </a>
        <a class="kt-header__topbar-username kt-hidden-mobile" *ngIf="showHi">{{ truncatedUser }}</a>
      </div>
      <span class="kt-header__topbar-icon" [ngClass]="{ 'kt-header__topbar-icon--brand' : iconType === 'brand' }">
        <a href="javascript:;" class="avatar-btn">
          <i *ngIf="!useSVG">
            <img *ngIf="!profilePhoto" alt="avatar-icon" src="../../../../../../assets/media/icons/avatar.jpg" />
            <img *ngIf="profilePhoto" [src]="profilePhoto" alt="profile-icon" class="user-profile-img" />
          </i>
        </a>
      </span>
    </div>
  </div>

  <div ngbDropdownMenu aria-labelledby="dropdownBasic1"
    class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround">
    <ul class="kt-nav kt-margin-t-10 kt-margin-b-10">
      <li class="kt-nav__item" [ngClass]="{ 'kt-nav__item--active': activeMenu === 'my-profile' }">
        <a [routerLink]="['/my-profile']" (click)="openMyProfile()" class=" kt-nav__link">
          <span class="kt-nav__link-icon">
            <img src="../../../../../../assets/media/icons/administration-icon.svg" alt="administration-icon" />
          </span>
          <span class="kt-nav__link-text">{{'MyProfile.Profile' | translate}}</span>
        </a>
      </li>
      <li class="kt-nav__item" [ngClass]="{ 'kt-nav__item--active': activeMenu === 'my-settings' }">
        <a [routerLink]="['/my-settings']" (click)="activeMenu = 'my-settings'" class=" kt-nav__link">
          <span class="kt-nav__link-icon">
            <img src="../../../../../../assets/media/icons/email.svg" alt="communication-icon" />
          </span>
          <span class="kt-nav__link-text">{{'MyProfile.MySettings' | translate}}</span>
        </a>
      </li>
      <li class="kt-nav__item" *ngIf="patientList?.length > 1">
        <a href="javascript:;" (click)="openPatientList()" class=" kt-nav__link">
          <span class="kt-nav__link-icon">
            <img src="../../../../../../assets/media/icons/switch-user-icon.svg" alt="switch-user-icon" />
          </span>
          <span class="kt-nav__link-text">{{'admin.SwitchUser'|translate}}</span>
        </a>
      </li>
      <li class="kt-nav__item" *ngIf="isAdminLogin"
        [ngClass]="{ 'kt-nav__item--active': activeMenu === 'account-overview' }">
        <a [routerLink]="['/account-overview']" (click)="openAccountOverviewDialog()" class=" kt-nav__link">
          <span class="kt-nav__link-icon">
            <img src="../../../../../../assets/media/icons/view-report-icon.png" alt="administration-icon" />
          </span>
          <span class="kt-nav__link-text">{{'MyProfile.AccountOverview' | translate}}</span>
        </a>
      </li>
      <li class="kt-nav__item" [ngClass]="{ 'kt-nav__item--active': activeMenu === 'language' }"
        (click)="activeMenu = 'language'">
        <kt-language-selector #languageSelector></kt-language-selector>
      </li>

      <li class="kt-nav__item" [ngClass]="{ 'kt-nav__item--active': activeMenu === 'change-password' }">
        <a href="javascript:;" (click)="openChangePasswordDialog()" class=" kt-nav__link">
          <span class="kt-nav__link-icon">
            <img src="../../../../../../assets/media/icons/password-icon.png" alt="password-icon" />
          </span>
          <span class="kt-nav__link-text">{{'MyProfile.ChangePassword' | translate}}</span>
        </a>
      </li>
      <li class="kt-nav__item" [ngClass]="{ 'kt-nav__item--active': activeMenu === 'sign-out' }">
        <a href="javascript:;" (click)="logout()" class="kt-nav__link">
          <span class="kt-nav__link-icon">
            <img src="../../../../../../assets/media/icons/signout-icon.svg" alt="signout-icon" />
          </span>
          <span class="kt-nav__link-text">
            {{ 'common.Signout' | translate }}
          </span>
        </a>
      </li>
    </ul>
  </div>
</div>